import React, { useEffect } from 'react';
import {
  FDContentContainer, FDStack, FDBodyText, FDBox,
} from '@facet-wealth/design';
import PropTypes from 'prop-types';
import ScenarioSelectionRedefinedStepContentHeader
  from 'Views/Page/Content/Templates/WizardTemplates/ScenarioSelectionRedefined/ScenarioSelectionRedefinedWrapperTemplate/ScenarioSelectionRedefinedStepLayoutWithContentHeader/ScenarioSelectionRedefinedStepContentHeader';
import { LottieLoadingLayout } from 'Organisms/LottieControl/LottieLoadingLayout';
import {
  FadeInBox,
} from 'Views/Page/Content/Templates/WizardTemplates/ScenarioSelectionRedefined/ScenarioSelectionRedefinedCommon/ExecuteSelectLoadingPage/FadeInBox';
import { ModuleProgressStepper } from 'Organisms/ModuleProgressStepper/ModuleProgressStepper';
import { useSnackbarContext } from 'Context/SnackbarContext';


const ScenarioSelectionRedefinedStepLayoutWithContentHeader = ({ resource, layout, errors }) => {
  const LayoutComponent = layout;
  const hasProgressSteps = resource.attr('progressSteps')?.resources().length() > 0;
  const { displayErrorMessage } = useSnackbarContext();

  // We may have an unexpected error on step submission so we should at least display some error message rather than
  // just crashing the page or having submission fail with no messaging.
  useEffect(() => {
    if (errors?.length > 0) {
      displayErrorMessage(errors, errors[0]?.detail || 'An unexpected error has occurred!');
    }
  }, [errors]);

  return (
    <FDContentContainer maxWidth="lg">
      <FDStack direction="column" spacing={5} alignItems="center" width={'100%'}>
        {hasProgressSteps ? <ModuleProgressStepper stepCollection={resource.attr('progressSteps')} /> : null }
        <FDBox width={'100%'}>
          <LottieLoadingLayout>
            <FadeInBox>
              <FDStack direction="column" spacing={5} paddingY={2} alignItems="center">
                <ScenarioSelectionRedefinedStepContentHeader resource={resource} />
                <LayoutComponent resource={resource} />
                <FDBodyText size={'sm'} value={resource.attr('disclaimerText')} color={'textDisabled'} align={'center'} />
              </FDStack>
            </FadeInBox>
          </LottieLoadingLayout>
        </FDBox>
      </FDStack>
    </FDContentContainer>
  );
};

ScenarioSelectionRedefinedStepLayoutWithContentHeader.defaultProps = {
  errors: null,
};

ScenarioSelectionRedefinedStepLayoutWithContentHeader.propTypes = {
  resource: PropTypes.object.isRequired,
  layout: PropTypes.oneOfType([PropTypes.element, PropTypes.func, PropTypes.node]).isRequired,
  errors: PropTypes.array,
};

export default ScenarioSelectionRedefinedStepLayoutWithContentHeader;
